import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Ban, Loader2, Save } from "lucide-react";

export const FlagCustomerCard = ({ customer, onSaved }) => {
  const [flagged, setFlagged] = useState(!!customer.do_not_service);
  const [reason, setReason] = useState(customer.flag_reason || "");
  const [saving, setSaving] = useState(false);
  const dirty = flagged !== !!customer.do_not_service || (flagged && reason !== (customer.flag_reason || ""));

  const save = async () => {
    setSaving(true);
    try {
      const res = await api.patch(`/admin/customers/${encodeURIComponent(customer.email)}/flag`, { do_not_service: flagged, reason });
      onSaved(res.data);
      toast.success(flagged ? "Customer flagged — online bookings blocked" : "Flag removed");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't update flag");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={`surface-card p-5 sm:p-6 ${flagged ? "border-2 border-red-500" : ""}`} data-testid="customer-flag-card">
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-2">
          <Ban className={`size-4 ${flagged ? "text-red-600" : "text-spark-teal"}`} />
          <p className={`label-mono ${flagged ? "text-red-600" : "text-spark-teal"}`}>Do not service</p>
        </div>
        <Switch checked={flagged} onCheckedChange={setFlagged} data-testid="customer-flag-toggle" />
      </div>
      <p className="text-xs text-spark-slate mb-3">
        Admin only. When on, this email and phone number can't book online — they'll see a polite "please contact us" message and you'll get an alert.
      </p>
      {flagged && (
        <textarea
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="input-style resize-none text-sm"
          placeholder="Private reason, e.g. repeated no-shows, abusive messages"
          data-testid="customer-flag-reason"
        />
      )}
      {customer.do_not_service && customer.flagged_at && (
        <p className="text-[11px] text-spark-slate mt-2" data-testid="customer-flagged-at">Flagged {new Date(customer.flagged_at).toLocaleString("en-NZ")}</p>
      )}
      <button onClick={save} disabled={saving || !dirty} className="btn-primary w-full mt-3" data-testid="customer-flag-save">
        {saving ? <Loader2 className="size-4 animate-spin" /> : <Save className="size-4" />} Save flag
      </button>
    </div>
  );
};
